export default Object.freeze( {
    collections: [
        {
            canvases: [
                {
                    id: 3,
                    name: 'New DMARC Outbound Canvas',
                    params: {
                        previousDays: 30
                    },
                    widgets: [
                        {
                            agGrid: [
                                {
                                    'default': true,
                                    field: 'orgDomain',
                                    headerName: 'Org Domain',
                                    hide: true,
                                    type: [
                                        'hiddenGroupColumn'
                                    ]
                                },
                                {
                                    'default': true,
                                    field: 'domainName',
                                    headerName: 'Domain',
                                    hide: false,
                                    sort: 'asc',
                                    type: [
                                        'groupableColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    field: 'domainType',
                                    headerName: 'Domain Type',
                                    hide: true,
                                    type: [
                                        'stringColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    enableValue: true,
                                    field: 'domainCount',
                                    headerName: 'FQDN(s)',
                                    hide: true,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    'default': true,
                                    field: 'dmarcPolicy',
                                    headerName: 'DMARC Policy',
                                    hide: false,
                                    type: [
                                        'policyIconColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    'default': true,
                                    enableValue: true,
                                    field: 'authorizedMailVolume',
                                    headerName: 'Messages (by permitted sender)',
                                    hide: false,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    'default': true,
                                    enableValue: true,
                                    field: 'dmarcPassRate',
                                    fieldParams: {
                                        rateCountField: 'dmarcPassCount'
                                    },
                                    headerName: 'DMARC Pass Rate (% of permitted msg)',
                                    hide: false,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'spfPassAlignRate',
                                    fieldParams: {
                                        rateCountField: 'spfPassAlignCount'
                                    },
                                    headerName: '(SPF) DMARC Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dkimPassAlignRate',
                                    fieldParams: {
                                        rateCountField: 'dkimPassAlignCount'
                                    },
                                    headerName: '(DKIM) DMARC Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dmarcDoublePassRate',
                                    fieldParams: {
                                        rateCountField: 'dmarcDoublePassCount'
                                    },
                                    headerName: 'DMARC Double Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'spfPassRate',
                                    fieldParams: {
                                        rateCountField: 'spfPassCount'
                                    },
                                    headerName: 'SPF Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dkimPassRate',
                                    fieldParams: {
                                        rateCountField: 'dkimPassCount'
                                    },
                                    headerName: 'DKIM Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'spfAlignRate',
                                    fieldParams: {
                                        rateCountField: 'spfAlignCount'
                                    },
                                    headerName: 'SPF Alignment Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dkimAlignRate',
                                    fieldParams: {
                                        rateCountField: 'dkimAlignCount'
                                    },
                                    headerName: 'DKIM Alignment Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'percentBlocked',
                                    fieldParams: {
                                        rateCountField: 'percentBlockedCount'
                                    },
                                    headerName: 'Block Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'unauthorizedMailVolume',
                                    headerName: 'Messages (by not permitted/undetermined sender)',
                                    hide: true,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    'default': true,
                                    enableValue: true,
                                    field: 'actionsCount',
                                    headerName: 'Actions',
                                    hide: false,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ]
                                }
                            ],
                            dataGrid: { h: 1, maxH: 2, maxW: 2, minH: 1, minW: 1, w: 1, x: 0, y: 0 },
                            exportable: true,
                            id: 0,
                            name: 'My Domains',
                            type: 'myDomainsTable',
                        },
                        {
                            dataGrid: { h: 1, maxH: 2, maxW: 2, minH: 1, minW: 1, w: 1, x: 1, y: 0 },
                            exportable: false,
                            id: 1,
                            name: 'Identify Permitted Senders',
                            type: 'unverifiedSenders',
                        },
                        {
                            agGrid: [
                                {
                                    'default': true,
                                    field: 'name',
                                    headerName: 'Sender',
                                    hide: false,
                                    sort: 'asc',
                                    type: [
                                        'stringColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    'default': true,
                                    field: 'domainCount',
                                    headerName: 'Permitted Domains',
                                    hide: false,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    'default': true,
                                    field: 'authorizedMailVolume',
                                    headerName: 'Messages (for permitted domains)',
                                    hide: false,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    'default': true,
                                    field: 'verifiedDmarcPassRate',
                                    headerName: 'DMARC Pass Rate (% of permitted msg)',
                                    hide: false,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'spfPassAlignRate',
                                    fieldParams: {
                                        rateCountField: 'spfPassAlignCount'
                                    },
                                    headerName: '(SPF) DMARC Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dkimPassAlignRate',
                                    fieldParams: {
                                        rateCountField: 'dkimPassAlignCount'
                                    },
                                    headerName: '(DKIM) DMARC Pass Rate (% of permitted msg)',
                                    hide: true,
                                    sortingOrder: ['asc','desc'],
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn'
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dmarcDoublePassRate',
                                    fieldParams: {
                                        rateCountField: 'dmarcDoublePassCount'
                                    },
                                    headerName: 'DMARC Double Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'spfPassRate',
                                    fieldParams: {
                                        rateCountField: 'spfPassCount'
                                    },
                                    headerName: 'SPF Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn'
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dkimPassRate',
                                    fieldParams: {
                                        rateCountField: 'dkimPassCount'
                                    },
                                    headerName: 'DKIM Pass Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'spfAlignRate',
                                    fieldParams: {
                                        rateCountField: 'spfAlignCount'
                                    },
                                    headerName: 'SPF Alignment Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'dkimAlignRate',
                                    fieldParams: {
                                        rateCountField: 'dkimAlignCount'
                                    },
                                    headerName: 'DKIM Alignment Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'percentBlocked',
                                    fieldParams: {
                                        rateCountField: 'percentBlockedCount'
                                    },
                                    headerName: 'Block Rate (% of permitted msg)',
                                    hide: true,
                                    type: [
                                        'rateColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                                {
                                    enableValue: true,
                                    field: 'unauthorizedMailVolume',
                                    headerName: 'Messages (for not permitted/undetermined domains)',
                                    hide: true,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ]
                                },
                                {
                                    'default': true,
                                    field: 'actions',
                                    headerName: 'Actions',
                                    hide: false,
                                    type: [
                                        'numberColumn',
                                        'rightAlignColumn',
                                        'sortAscDescColumn',
                                    ],
                                },
                            ],
                            dataGrid: { h: 1, maxH: 2, maxW: 2, minH: 1, minW: 1, w: 1, x: 0, y: 1 },
                            exportable: true,
                            id: 2,
                            name: 'My Senders',
                            subtitle: 'Permitted Senders',
                            type: 'mySendersTable',
                        },
                    ]
                }
            ],
            icon: 'dashboard',
            id: 0,
            name: 'Interactive Canvases',
            order: 1
        },
        {
            canvases: [
                {
                    id: 'claimed-domains',
                    name: 'Claimed Domains'
                },
                {
                    id: 'discovered-domains',
                    name: 'Discovered Domains'
                }
            ],
            icon: 'build',
            id: 'system',
            name: 'System',
            order: 3
        }
    ]
} );
